import { FC } from "react";
import { useTypedDispatch } from "../../hooks/useTypedDispatch";
import { useTypedSelector } from "../../hooks/useTypedSelector";
import { getActiveOrderItemId, getOrder, setActiveOrderItemId } from "../../store/orderSlice";
import OrderItem from "./OrderItem";

const OrderInfo: FC = () => {
  const dispatch = useTypedDispatch();
  const order = useTypedSelector(getOrder());
  const activeOrderItemId = useTypedSelector(getActiveOrderItemId());
  if (!order) return null; 

  return (
    <div className="border-border_color border-[1px] rounded-md p-4">
      {/*
        The action buttons that used to sit on the right are gone: OrderTabs above
        already links to Track Shipment, Return Item, Cancel Order and Contact Us.
        The freed width goes to the product cards and their PartsCare badge.
      */}
      <div className="flex flex-col gap-4">
        {(order?.orderItems || []).map((orderItem) => (
          <OrderItem
            key={`order-item-${orderItem.id}`}
            isSelected={activeOrderItemId === orderItem.id}
            select={() => dispatch(setActiveOrderItemId(orderItem.id))}
            {...orderItem}
          />))}
      </div>
    </div>
  );
}

export default OrderInfo;
